module.exports = __webpack_public_path__ + "img/banner2.9919d8f.jpg";